<template>
  <div id="app">
    <transition name="show-from-left">
        <popover name="helpfailf" :width="240">
          <Help :titleChart="titleChart"> 
            <div slot="content">
              <p>{{ $t("224") }}</p>
            </div>     
          </Help>
      </popover>
    </transition>

    <div class="title-charts">{{ $t("225") }}
      <button class="bt-help" v-popover:helpfailf.right><i class="icon-help ti-help-alt"></i></button>
    </div>

    <div class="container-fluid">
        <div class="row">

          <highcharts :options="chartOptions" ref='chart'></highcharts>     

        </div>
    </div>

  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'

import Vue from 'vue'
import axios from 'axios';
import mixin from '../../../../utils/mixin'

import Popover  from 'vue-js-popover'
Vue.use(Popover)

import Help from 'src/components/Dashboard/Views/components/Help'

export default {
  name: 'charts',
  components: {
    Help
  },
  data () {
    return {
      titleChart: this.$t("225"),
      tableData: [],      
      chartOptions: {
        //verde, vermelho,laranja, azul
        colors: ['#90ed7d', '#ff7f23', '#f45b5b', '#f45b5b', '#104E8B'],
        chart: {
          type: 'line',
          backgroundColor: 'rgba(0,0,0,0)',
          style: {
            fontFamily: '\'Unica One\', sans-serif'
          },
          plotBorderColor: '#606063'
        },
        title: {
            text: '',
            style: {
                color: '#fff',
                textTransform: 'uppercase',
                fontSize: '16px',
                fontWeight: 'bold'
            }
        },
        subtitle: {
            style: {
                color: '#E0E0E3',
                textTransform: 'uppercase'
            }
        },
        xAxis: {
            categories: [],
            crosshair: true,
            gridLineColor: '#707073',
            labels: {
                style: {
                    color: '#fff'
                }
            },
            lineColor: '#707073',
            minorGridLineColor: '#505053',
            tickColor: '#707073',
            title: {
                text: '',
                style: {
                    color: '#A0A0A3',
                }
            }
        },
        yAxis: [{
            min: 0,
            tickInterval: 50,
            title: {
                text: this.$t("136"),
                style: {
                    color: '#A0A0A3',
                    fontSize: '12px',
                }
            },
            stackLabels: {
                enabled: true,
                style: {
                    fontWeight: 'bold',
                    color: 'white'
                }
            },
            gridLineColor: '#707073',
            labels: {
                style: {
                    color: '#E0E0E3'
                }
            },
            lineColor: '#707073',
            minorGridLineColor: '#505053',
            tickColor: '#707073',
            tickWidth: 1,
        }, { // Secondary yAxis
            min: 0,
            tickInterval: 2,
            title: {
                text: this.$t("140_1"),
                style: {
                    color: '#A0A0A3',
                    fontSize: '12px',
                }
            },
            gridLineColor: '#707073',
            labels: {                
                style: {
                    color: '#E0E0E3'
                }
            },
            lineColor: '#707073',
            minorGridLineColor: '#505053',
            tickColor: '#707073',
            tickWidth: 1,
            opposite: true
        }],
        tooltip: {
            backgroundColor: 'rgba(0, 0, 0, 0.85)',
            style: {
                color: '#F0F0F0'
            },
            headerFormat: '<span style="font-size:10px;">{point.key}</span><table>',
            pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
                '<td style="padding:0"><b> {point.y} </b></td></tr>',
            footerFormat: '</table>',
            shared: true,
            useHTML: true
        },
        plotOptions: {
            /*series: {
                dataLabels: {
                    enabled: true,
                    color: '#F0F0F3',
                    style: {
                        fontSize: '13px'
                    }
                },
                marker: {
                    lineColor: '#333'
                },
                events:{
                    //click: this.loadGrid
                },
                cursor: 'pointer'
            },
            boxplot: {
                fillColor: '#505053'
            },
            candlestick: {
                lineColor: 'white'
            },
            errorbar: {
                color: 'white'
            },*/
            column: {
                stacking: 'normal',
                dataLabels: {
                  enabled: false
                }
            },
            spline: {                
                stacking: 'normal',
                dataLabels: {
                  enabled: true,
                  format: '<span style="position: absolute; top: 20px">{point.y} %</span>',
                  color: '#fff',
                  backgroundColor: 'rgba(0, 0, 0, 0.85)',
                  allowOverlap: true,                  
                  x: 0,
                  y: -10                  
                },                
            },
        },
        legend: {
          title: {
              style: {
                  color: '#C0C0C0',
                  fontSize: '12px'
              }
          },
          itemStyle: {
              color: '#E0E0E3'
          },
          itemHoverStyle: {
              color: '#FFF'
          },
          itemHiddenStyle: {
              color: '#b0adad'
          },
          layout: 'horizontal',
          align: 'left',
          x: 50,
          verticalAlign: 'top',
          y: 0,
          floating: false,
          color: 'white',
          backgroundColor:
              // theme
              'rgba(255,255,255,0.25)'
        },
        labels: {
            style: {
                color: '#fff'
            }
        },
        drilldown: {
            activeAxisLabelStyle: {
                color: '#F0F0F3'
            },
            activeDataLabelStyle: {
                color: '#F0F0F3'
            }
        },
        navigation: {
            buttonOptions: {
                symbolStroke: '#DDDDDD',
                theme: {
                    fill: '#505053'
                }
            }
        },
        rangeSelector: {
            buttonTheme: {
                fill: '#505053',
                stroke: '#000000',
                style: {
                    color: '#CCC'
                },
                states: {
                    hover: {
                        fill: '#707073',
                        stroke: '#000000',
                        style: {
                            color: 'white'
                        }
                    },
                    select: {
                        fill: '#000003',
                        stroke: '#000000',
                        style: {
                            color: 'white'
                        }
                    }
                }
            },
            inputBoxBorderColor: '#505053',
            inputStyle: {
                backgroundColor: '#333',
                color: 'silver'
            },
            labelStyle: {
                color: 'silver'
            }
        },
        navigator: {
            handles: {
                backgroundColor: '#666',
                borderColor: '#AAA'
            },
            outlineColor: '#CCC',
            maskFill: 'rgba(255,255,255,0.1)',
            series: {
                color: '#7798BF',
                lineColor: '#A6C7ED'
            },
            xAxis: {
                gridLineColor: '#505053'
            }
        },
        scrollbar: {
            barBackgroundColor: '#808083',
            barBorderColor: '#808083',
            buttonArrowColor: '#CCC',
            buttonBackgroundColor: '#606063',
            buttonBorderColor: '#606063',
            rifleColor: '#FFF',
            trackBackgroundColor: '#404043',
            trackBorderColor: '#404043'
        },
        series: [{
            type: 'column',
            name: this.$t("136"),
            //data: [617, 224, 443, 401, 896, 77],
            data: [],
            yAxis: 0,
           
        },
        {
            type: 'column',
            name: 'R1 - R2',
            //data: [91, 53, 80, 66, 129, 0],
            data: [],
            yAxis: 0,
        }, 
        {
            type: 'column',
            name: 'R3+',
            //data: [21, 21, 23, 17, 28, 0]
            data: [],
            yAxis: 0,
        }, 
        {
            type: 'spline',
            name: this.$t("139"),
            //data: [5.4, 4.9, 6.4, 3.7, 5.8, 2.1], 
            data: [],             
            yAxis: 1,
            marker: {
              lineWidth: 3,
              lineColor:'#f45b5b',
              fillColor: '#f45b5b'
            },
            tooltip: {
              valueSuffix: ' %'
            }
        },
        {
            type: 'spline',
            name: this.$t("140"),            
            //data: [5.4, 5.15, 5.57, 5.1, 5.24, 4.72],
            data: [],
            color: '#104E8B',
            yAxis: 1,
            marker: {
              lineWidth: 3,
              lineColor:' #104E8B',
              fillColor: '#104E8B'              
            },
            tooltip: {
              valueSuffix: ' %'
            },
            dataLabels: {
            		enabled: true,
                y: -15
            }

        }

        ],
        exporting: { enabled: false },
        credits: {
          enabled: false
        },
        loading: {
            labelStyle: {
                color: 'black',
                textShadow: '1px 0 0 #fff, -1px 0 0 #fff, 0 1px 0 #fff, 0 -1px 0 #fff, 1px 1px #fff, -1px -1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff',
            },
            style: {
                backgroundColor: 'none',
                opacity: 1,
            }
        },
      },
    }
  },
  mixins: [mixin],
  methods: {
    ...mapMutations(['changeGrid']),

    loadGrid(event){        

    },
    getData(){
 
      const API = process.env.ROOT_API;
      const ENDPOINT = 'v1/mysemeq-ambev/get-failure-rate'
      let self = this;

      this.$refs.chart.chart.showLoading();      

      axios({method: 'GET', url: API + ENDPOINT, params: {...this.filtersOn, 'online': 1, plant: this.filtersOn.planta, area: this.filtersOn.area_f, sector: this.filtersOn.sector_f, component: this.filtersOn.subset}, headers: { Authorization: `Bearer ${localStorage.getItem('user-token')}` }})
      .then(resp => {
      self.tableData = resp.data;     
      self.$refs.chart.chart.hideLoading();
      })
      .catch(err => {
      // from mixin
      self.ApiErrorHandler(self, error.response.data.status_code);
      self.$refs.chart.chart.showLoading('Error');
      })
    },
    setChartData () {

      var self = this
        var res = self.tableData

        self.chartOptions.xAxis.categories = []
        self.chartOptions.series[0].data = []
        self.chartOptions.series[1].data = []
        self.chartOptions.series[2].data = []
        self.chartOptions.series[3].data = []
        self.chartOptions.series[4].data = []
        if(res) {
            res.forEach(function (it) {
                self.chartOptions.xAxis.categories.push(it.ref_date)
                self.chartOptions.series[0].data.push(it.no_repetition)
                self.chartOptions.series[1].data.push(it.repetition_yellow)
                self.chartOptions.series[2].data.push(it.repetition_red)
                self.chartOptions.series[3].data.push(it.percentage)
                self.chartOptions.series[4].data.push(it.monthy_accumulated)
            })
        }


    },
  },
  computed: {
    ...mapGetters(['filtersOn']),
  },
  watch: {
    filtersOn: function(newValue){
        this.getData();
    },
    tableData: function(){
      this.setChartData();
    }
  },
  
}
</script>
<style scoped>
.chart-opt{
  margin-top: 60px!important;
}
tspan {
    /*fill: #fff;*/
    stroke: none!important;
    stroke-width: 1px;
    stroke-linejoin: round;
    /*color: #fff;*/
 /*   font-weight: normal;
    font-size: 14px;*/
}
.highcharts-drilldown-data-label text{
  text-decoration:none !important;
}

div[data-popover="helpfailf"] {
  left: 58% !important;
  top:0%!important;
}

.box-failure{
  width: 32.3%;
  float: left;
  border: 1px solid #666464;
  border-radius: 5px;
  height: 65px;
  padding:15px 5px;
  margin:5px 5px;

}
.top-title-fail{
  text-align: left;
  font-size: 20px;
  font-weight: bold;
  color: #fff;
}
.top-title-fail-planta{
  text-align: left;
  font-size: 12px;
  font-weight: bold;
  color: #fff;
}

.top-prc-fail{
  text-align: right;
  font-weight: bold;
  font-size: 22px;
  color: #fff;
}
.fail-result{
  border-radius: 11px;
  text-align: center;
}
.rs-red{
  background-color: #f45b5b;
}
.rs-green{
  background-color: #90ed7d;
}
.rs-yellow{
  background-color: #e4d354;
}

.fail-NAZ{
  background-image: url('/static/img/naz-img.jpg');
  background-repeat: no-repeat;
  background-size: 100% auto;
}
.fail-SAZ{
  background-image: url('/static/img/skol-img.jpg');
  background-repeat: no-repeat;
  background-size: 100% auto;
}

.fail-MAZ{
  background-image: url('/static/img/corona-img.jpg');
  background-repeat: no-repeat;
  background-size: 100% auto;
}
.fail-AFR{
  background-image: url('/static/img/castle-img.jpg');
  background-repeat: no-repeat;
  background-size: 100% auto;
}
.fail-EUR{
  background-image: url('/static/img/stella-img.jpg');
  background-repeat: no-repeat;
  background-size: 100% auto;
}
.fail-APAC{
  background-image: url('/static/img/harbin-img.jpg');
  background-repeat: no-repeat;
  background-size: 100% auto;
}

</style>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/ChartsOnline/ChartFailureOnline.vue